<template>
  <div class="unit-list">
    <br />
    <br />
    <SearchFilter
      v-if="!(isSearchResult === false && unit.units.length === 0)"
    />
    <div
      style="height: 100vh;"
      v-if="isSearchResult === true && unit.units.length === 0"
    >
      <!-- <PulseIcon v-on:click.native="allowToAdd();"/> -->
      {{ $t('noSearchResult') }}
      <!-- <br><button class="add-btn" @click="clearSearchResult()">
        {{ $t('clearSearch') }}
      </button> -->
    </div>

    <div
      v-else-if="isSearchResult === false && unit.units.length === 0"
      class="unitsEmpty"
    >
      <br />
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/unit.svg" />
      </figure>
      <!-- <router-link :to="'/' + 'units/create/' + $i18n.locale"><p> -->
      <button class="add-btn" @click="allowToAdd">
        {{ $t('addFirstUnit') }}
      </button>
      <!-- </p></router-link>                -->
    </div>

    <div v-else class="unitsEntered">
      <!-- <template v-if="unit.units.length < subscription.subscription.unit_count">
			<PulseIcon class="addUnitBtnMobile" v-on:click.native="allowToAdd();"/>
		</template> -->

      <div class="addBtnWrapper1" v-on:click="allowToAdd()">
        <div class="addIcon">
          <!-- <font-awesome-icon icon="location-plus" />
              <font-awesome-icon class="iconBig" icon="tag" /> -->
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512; fill: white;"
            xml:space="preserve"
          >
            <g>
              <path
                d="M256,512c0,0,205.52-142.33,204.8-307.2C460.8,91.88,368.9,0,256,0C143.08,0,51.2,91.88,51.2,204.68
							C50.45,369.67,248.2,506.48,256,512z M153.6,179.2h76.8v-76.8h51.2v76.8h76.8v51.2h-76.8v76.8h-51.2v-76.8h-76.8V179.2z"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="addBtnWrapper2" @click="openSelectBoxForQRCodeLayoutModal">
        <div class="addIcon">
          <!-- <font-awesome-icon icon="location-plus" />
              <font-awesome-icon class="iconBig" icon="tag" /> -->
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 122.88 122.7"
            style="enable-background:new 0 0 512 512; fill: white;"
            xml:space="preserve"
          >
            <g>
              <path
                class="st0"
                d="M0.18,0h44.63v44.45H0.18V0L0.18,0z M111.5,111.5h11.38v11.2H111.5V111.5L111.5,111.5z M89.63,111.48h11.38 v10.67H89.63h-0.01H78.25v-21.82h11.02V89.27h11.21V67.22h11.38v10.84h10.84v11.2h-10.84v11.2h-11.21h-0.17H89.63V111.48 L89.63,111.48z M55.84,89.09h11.02v-11.2H56.2v-11.2h10.66v-11.2H56.02v11.2H44.63v-11.2h11.2V22.23h11.38v33.25h11.02v11.2h10.84 v-11.2h11.38v11.2H89.63v11.2H78.25v22.05H67.22v22.23H55.84V89.09L55.84,89.09z M111.31,55.48h11.38v11.2h-11.38V55.48 L111.31,55.48z M22.41,55.48h11.38v11.2H22.41V55.48L22.41,55.48z M0.18,55.48h11.38v11.2H0.18V55.48L0.18,55.48z M55.84,0h11.38 v11.2H55.84V0L55.84,0z M0,78.06h44.63v44.45H0V78.06L0,78.06z M10.84,88.86h22.95v22.86H10.84V88.86L10.84,88.86z M78.06,0h44.63 v44.45H78.06V0L78.06,0z M88.91,10.8h22.95v22.86H88.91V10.8L88.91,10.8z M11.02,10.8h22.95v22.86H11.02V10.8L11.02,10.8z"
              />
            </g>
          </svg>
        </div>
      </div>
      <br />
      <br />
      <transition-group
        class="unit-cards column"
        name="slide-up"
        tag="ul"
        appear
      >
        <UnitCard v-for="unit in unit.units" :key="unit.id" :unit="unit" />
      </transition-group>
    </div>
    <b-modal id="SelectBoxForQRCodeLayout-modal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <SelectBoxForQRCodeLayout 
          type="CLIENT"
          @close-modal="closeSelectBoxForQRCodeLayout"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import UnitCard from '@/components/ui/UnitCard.vue'
// import PulseIcon from '@/components/common/PulseIcon.vue'
import { mapState } from 'vuex'
import SelectBoxForQRCodeLayout from '@/components/forms/SelectBoxForQRCodeLayout.vue'
import SearchFilter from '@/components/common/SearchFilter.vue'

export default {
  data() {
    return {
      isSearchResult: false
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.tc('unit', 2)
    }
  },
  components: {
    UnitCard,
    SelectBoxForQRCodeLayout,
    // PulseIcon,
    SearchFilter
  },
  created() {
    this.$store.dispatch('unit/fetchUnits')
  },
  async mounted() {
    this.isSearchResult = false
  },
  methods: {
    allowToAdd() {
      this.$store.dispatch('client/profileCompleteness').then(response => {
        if (response && response.profile_complete === true) {
          this.$router.push({
            name: 'unit-create',
            params: { lang: this.$i18n.locale }
          })
        } else {
          alert(this.$t('completeProfileFirst'))
        }
      })
    },
    async searchTerm(search) {
      await this.$store.dispatch('unit/searchUnits', search)
      this.isSearchResult = true
    },
    clearSearch() {
      this.$store.dispatch('unit/fetchUnits')
      this.isSearchResult = false
    },
    openSelectBoxForQRCodeLayoutModal() {
      this.$bvModal.show('SelectBoxForQRCodeLayout-modal')
    },
    closeSelectBoxForQRCodeLayout() {
      this.$bvModal.hide('SelectBoxForQRCodeLayout-modal')
    }
  },
  computed: mapState(['unit', 'client', 'subscription'])
}
</script>

<style lang="scss" scoped>
.unitsEmpty {
  // display: none; //! none when FIRST unit with this client_id is already found in db //
}
.unitsEntered {
  // display: none; //! none when NO unit with this client_id is found in db //
}

.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  width: 200px;
  border-radius: 5px;
  margin-left: 30px;
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.addIcon {
  cursor: pointer;
  padding: 5px;
}

.unit-list {
  margin-top: 0px;
  height: 100vh;
  width: 100%;
}
.unit-cards {
  margin-top: 20px;
  padding: 0;
}

.addBtnWrapper1 {
  background-color: var(--primaryDark);
  color: var(--bright);
  width: 60px;
  padding: 8px;
  margin: -110px auto 10px 20px;
  border-radius: 10px;
}
.addBtnWrapper1:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--bright);
  color: var(--bg);
  transition: 0.25s box-shadow, 0.25s transform;
}
.addBtnWrapper2 {
  background-color: var(--primaryDark);
  color: var(--bright);
  width: 60px;
  padding: 5px;
  margin: -70px 60px 60px 80px;
  border-radius: 10px;
  margin-left: 100px;
}
.addBtnWrapper2:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--bright);
  color: var(--bg);
  transition: 0.25s box-shadow, 0.25s transform;
}
.iconBig {
  font-size: 1.4rem;
}

.column {
  display: flex;
  flex-flow: wrap;
  height: 100%;
  justify-content: center;
}

.addUnitBtnMobile {
  width: 100px;
}

@media screen and (max-width: 500px) {
  .addUnitBtnMobile {
    width: 50px;
    padding: 0.7em;
    margin-left: -10px;
    margin-top: -5px;
  }
  .unit-list {
    margin-top: 30px;
  }
  .addBtnWrapper1 {
    width: 15%;
    padding: 5px;
    margin: -130px auto 10px 20px;
  }
  .addBtnWrapper2 {
    width: 15%;
    padding: 5px;
    margin: -65px 60px 60px 80px;
    margin-left: 100px;
  }
  .add-btn {
    margin-left: 0px;
  }
}
</style>
